import { ConstantVariables } from "../../Helpers/ConstantVariables";

export class InformationPageManager {

    constructor(private containerElement: JQuery) { }

    private informationPageViewsList : JQuery<HTMLElement>;
    private informationViewContainer : JQuery<HTMLElement>;

    private currentSelectedView;
    private currentSelectedTopic;
    private currentSelectedSubTopic;

    public initialize() {
        var self = this;

        self.informationPageViewsList = self.containerElement.find('#information-page-views-list');
        self.informationViewContainer = self.containerElement.find('#information-view-container');

        self.currentSelectedView = self.informationPageViewsList.find('li.active').data('view');
        self.currentSelectedTopic = '';
        self.currentSelectedSubTopic = '';

        self.containerElement.find('[data-view]').each((index, element) => {
            var viewElement = $(element);
            var viewToLoad = viewElement.data('view');
            var topic = viewElement.data('topic');
            var subTopic = viewElement.data('sub-topic');


            viewElement.off('click').on('click', () => {
                if(self.currentSelectedView == viewToLoad && self.currentSelectedTopic == topic && self.currentSelectedSubTopic == subTopic) {
                    return;
                }

                if(self.currentSelectedView == viewToLoad && self.currentSelectedTopic == topic && self.currentSelectedSubTopic != subTopic) {
                    self.scrollToSubTopic(subTopic);
                    return;
                }

                self.documentationSubTopicObserver?.disconnect();
                $(window).off("scroll.documentationSubTopic");
                self.informationViewContainer.off("scroll.documentationSubTopic");

                if(viewToLoad != 'documentation') {
                    self.informationPageViewsList.find('li.active').removeClass('active');
                    viewElement.addClass('active');
                }

                self.currentSelectedView = viewToLoad;
                self.currentSelectedTopic = topic;
                self.currentSelectedSubTopic = subTopic;

                if(viewToLoad == 'company-info') {
                    self.informationViewContainer.parent().removeClass('tinymce-content-view-container');
                }
                else {
                    self.informationViewContainer.parent().addClass('tinymce-content-view-container');
                }

                self.informationViewContainer.html(ConstantVariables.SpinnerHtmlWithMargin).load(`?view=${viewToLoad}&topic=${encodeURIComponent(topic)}&handler=LoadInformationView`, () => {
                    if(viewToLoad == 'version-history') {
                        self.versionHistoryIsLoading = false;
                        self.versionHistoryHasMore = true;
                        self.initializeVersionHistoryLazyLoading();
                    } 
                    else if(viewToLoad == 'documentation') {
                        if(subTopic != undefined && subTopic.length > 0) {
                            self.scrollToSubTopic(subTopic);
                            self.informationPageViewsList.find('li.active').removeClass('active');
                            viewElement.addClass('active');
                            
                            setTimeout(() => {
                                self.initializeDocumentationSubTopicObserver();
                            }, 500)
                        }
                        else {
                            self.initializeDocumentationSubTopicObserver();
                        }

                        
                    }
                })
            })
        })
    }

    //#region Version history lazy loading

    private versionHistoryObserver: IntersectionObserver | null = null;
    private versionHistoryIsLoading = false;
    private versionHistoryHasMore = true;

    private initializeVersionHistoryLazyLoading(): void {
        this.versionHistoryObserver?.disconnect();

        const items = this.informationViewContainer.find(".version-history-item");

        if (!items.length || !this.versionHistoryHasMore) {
            return;
        }

        const lastItem = items.last()[0] as HTMLElement;

        this.versionHistoryObserver = new IntersectionObserver(
            entries => {
                const entry = entries[0];

                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                    void this.loadMoreVersionHistory();
                }
            },
            {
                threshold: 0.5
            }
        );

        this.versionHistoryObserver.observe(lastItem);
    }

    private async loadMoreVersionHistory(): Promise<void> {
        if (this.versionHistoryIsLoading || !this.versionHistoryHasMore) {
            return;
        }

        this.versionHistoryIsLoading = true;

        const spinner = this.informationViewContainer.find("#version-history-loading-spinner");
        spinner.removeClass("d-none");

        const items = this.informationViewContainer.find(".version-history-item");
        const lastItem = $(items.last());

        const lastDate = lastItem.data("version-history-date");

        try {
            const response = await fetch(
                `?view=version-history&versionHistoryDate=${encodeURIComponent(lastDate ?? "")}&handler=LoadInformationView`,
                {
                    method: "GET",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }
            );

            if (!response.ok) {
                spinner.addClass("d-none");
               return;
            }

            const html = await response.text();

            if (!html.trim()) {
                this.versionHistoryHasMore = false;
                this.versionHistoryObserver?.disconnect();
                return;
            }

            spinner.before(html);

            this.initializeVersionHistoryLazyLoading();
        } catch (error) {
            console.error(error);
        } finally {
            this.versionHistoryIsLoading = false;
            spinner.addClass("d-none");
        }
    }

    //#endregion

    //#region subtopic scrolling

    private documentationSubTopicObserver: IntersectionObserver | null = null;

    private scrollToSubTopic(subTopic: string) {
        var self = this;
        const targetElement = $(`.documentation-topic[data-sub-topic="${subTopic}"]`);

        if (targetElement.length) {
            targetElement.get(0).scrollIntoView({behavior: 'smooth'});
        }
        else {
            self.informationViewContainer.parent().animate({ scrollTop: 0 }, "smooth");
        }
    }

    private initializeDocumentationSubTopicObserver(): void {
        const self = this;

        self.documentationSubTopicObserver?.disconnect();

        $(window).off("scroll.documentationSubTopic");
        self.informationViewContainer.off("scroll.documentationSubTopic");

        const currentTopic = self.currentSelectedTopic;

        if (!currentTopic) {
            return;
        }

        const topics = self.informationViewContainer.find(".documentation-topic");


        if (!topics.length) {
            self.setDocumentationIntroductionActive(currentTopic);
            return;
        }

        const visibleTopics = new Map<string, IntersectionObserverEntry>();

        const thresholds: number[] = [];

        for (let i = 0; i <= 100; i++) {
            thresholds.push(i / 100);
        }

        const setActiveByScrollPosition = (): void => {
            const firstTopicElement = topics.first()[0] as HTMLElement | undefined;

            if (!firstTopicElement) {
                return;
            }

            const firstTopicRect = firstTopicElement.getBoundingClientRect();
            const firstTopicTop = firstTopicRect.top;
            const firstTopicHeight = firstTopicRect.height;

            const introductionBoundary = -(firstTopicHeight * 0.8);

            if (firstTopicTop >= introductionBoundary) {
                self.setDocumentationIntroductionActive(currentTopic);
                return;
            }

            let mostVisibleSubTopic: string | null = null;
            let highestVisiblePixels = 0;

            visibleTopics.forEach((entry, subTopic) => {
                const visiblePixels =
                    entry.intersectionRect.width * entry.intersectionRect.height;

                if (visiblePixels > highestVisiblePixels) {
                    highestVisiblePixels = visiblePixels;
                    mostVisibleSubTopic = subTopic;
                }
            });

            if (!mostVisibleSubTopic) {
                return;
            }

            if (self.currentSelectedSubTopic === mostVisibleSubTopic) {
                return;
            }

            const viewElement = self.informationPageViewsList.find("li").filter(function () {
                const item = $(this);

                return (
                    item.attr("data-view") === "documentation" &&
                    item.attr("data-topic") === currentTopic &&
                    item.attr("data-sub-topic") === mostVisibleSubTopic
                );
            }).first();

            if (!viewElement.length) {
                return;
            }

            self.informationPageViewsList.find("li.active").removeClass("active");
            viewElement.addClass("active");

            self.currentSelectedSubTopic = mostVisibleSubTopic;
        };

        self.documentationSubTopicObserver = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    const element = entry.target as HTMLElement;
                    const subTopic = element.getAttribute("data-sub-topic");

                    if (!subTopic) {
                        return;
                    }

                    if (entry.isIntersecting) {
                        visibleTopics.set(subTopic, entry);
                    } else {
                        visibleTopics.delete(subTopic);
                    }
                });

                setActiveByScrollPosition();
            },
            {
                root: null,
                threshold: thresholds
            }
        );

        topics.each((_, element) => {
            self.documentationSubTopicObserver?.observe(element);
        });

        $(window).on("scroll.documentationSubTopic", () => {
            setActiveByScrollPosition();
        });

        self.informationViewContainer.on("scroll.documentationSubTopic", () => {
            setActiveByScrollPosition();
        });

        setActiveByScrollPosition();

        setTimeout(() => {
            setActiveByScrollPosition();
        }, 100);
    }

    private setDocumentationIntroductionActive(topic: string): void {
        const self = this;

        const introductionElement = self.informationPageViewsList.find("li").filter(function () {
            const item = $(this);

            return (
                item.attr("data-view") === "documentation" &&
                item.attr("data-topic") === topic &&
                !item.attr("data-sub-topic")
            );
        }).first();

        if (!introductionElement.length) {
            return;
        }

        if (introductionElement.hasClass("active")) {
            return;
        }

        self.informationPageViewsList.find("li.active").removeClass("active");
        introductionElement.addClass("active");

        self.currentSelectedSubTopic = null;
    }

    //#endregion
}